import React, { SyntheticEvent, useState } from "react";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import { Autocomplete, TextField } from "@mui/material";
import { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { updateSelectedPrompt, personas } from "../../app/promptsSlice";

function PersonaFormControl() {
  const dispatch = useAppDispatch();
  const persona = useAppSelector(
    (state: RootState) => state.prompts.selectedPrompt.persona
  );
  const [possiblePersonas, setPossiblePersonas] = useState(personas);

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const newPersona = event.target.value;
    const mappedPersonas = [...personas];
    if (newPersona && newPersona !== "")
      mappedPersonas.unshift({ id: newPersona, name: newPersona });
    setPossiblePersonas(mappedPersonas);
    dispatch(updateSelectedPrompt({ persona: newPersona }));
  };

  const handleSelectChange = (
    event: SyntheticEvent<Element, Event>,
    newPersona: string | null
  ) => {
    dispatch(updateSelectedPrompt({ persona: newPersona }));
  };

  return (
    <Grid container spacing={2}>
      <FormControl fullWidth>
        <Autocomplete
          id="persona-textfield"
          freeSolo
          options={possiblePersonas.map((persona) => persona.name)}
          onChange={handleSelectChange}
          value={persona}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              onChange={handleChange}
              slotProps={{ inputLabel: { shrink: true } }}
              placeholder="e.g. Expert, Advisor"
              label="Persona"
              helperText="Choose a persona or add your own"
            />
          )}
        />
      </FormControl>
    </Grid>
  );
}

export default PersonaFormControl;
